"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logToGoogleAnalytics = void 0;
var constants_1 = require("../../constants");
var analytics_adapter_helper_1 = require("./analytics-adapter.helper");
var logToGoogleAnalytics = function (intent, businessName, offering, isEditorMode, trackEventFunc) {
    if (intent === constants_1.OfferingIntent.BOOK_OFFERING) {
        (0, analytics_adapter_helper_1.trackOfferingBookingClick)(offering, businessName, isEditorMode, trackEventFunc);
    }
    else {
        (0, analytics_adapter_helper_1.trackOfferingClickFromWidget)(offering, 0, isEditorMode, businessName, trackEventFunc);
    }
};
exports.logToGoogleAnalytics = logToGoogleAnalytics;
//# sourceMappingURL=analytics-adapter.js.map